export default __webpack_public_path__ + "static/media/R5C_8108.0a47ce7b.jpg";